import moment from "moment";
import mime from 'mime-types';
import { PDFDocument } from 'pdf-lib';
import { AES_KEY_ECD, AES_IV_ECD } from '../config/config.json'
import CryptoJS from "crypto-js";
import { typesDocsToValidateStatus, identityValidationIds, documentaryValidationIds, limitCharacters, arrayValidationConectors } from 'config/constants';
import { textValidationVIM, textVerification } from 'config/configMessages';
import { getDocumentsToValidateCheck } from './utils';

export const formatArray = (allowedFormats) => {
    const defaultAllowedFormats = "jpg";
    const allowedFormatsFinal = allowedFormats && allowedFormats !== "" && allowedFormats !== undefined ? allowedFormats : defaultAllowedFormats;


    // return allowedFormatsFinal.split(',').map(format => {
    //     const trimmedFormat = format.trim().toLowerCase();
    //     console.log("🚀 ~ file: generalUtils.js:12 ~ returnallowedFormatsFinal.split ~ trimmedFormat:", trimmedFormat)
    //     const mimeType = trimmedFormat === "csr" ? "application/pkcs10 csr pkcs10 csr.txt" : mime.lookup(trimmedFormat);
    //     console.log("🚀 ~ file: generalUtils.js:13 ~ returnallowedFormatsFinal.split ~ mimeType:", mimeType)
    //     return mimeType;
    // }).filter(format => format !== false);

    const customMimeTypes = {
        csr: ["application/csr", "application/pkcs10", "application/txt", "application/csr.txt"]
    };

    return allowedFormatsFinal
        .split(",")
        .map((format) => {
            const trimmedFormat = format.trim().toLowerCase();
            return customMimeTypes[trimmedFormat] || mime.lookup(trimmedFormat);
        })
        .filter((mimeType) => mimeType !== false);
}

export const convertToMb = (allowedWeight) => {

    const defaultAllowedWeight = "8";
    const allowedWeightFinal = allowedWeight && allowedWeight !== "" && allowedWeight !== undefined ? allowedWeight : defaultAllowedWeight;

    return parseInt(allowedWeightFinal) * 1024 * 1024;
}

export const getDocumentTypeAppliesCF = (documentTypeId) => {
    documentTypeId = documentTypeId.replace(" ", "").replace(".", "");
    switch (documentTypeId) {
        case "CC":
            return "1";
        case "CE":
            return "3";
        default:
            return "4"; // Valor por defecto si no coincide con ninguno
    }
}
export const searchByDocumentType = (data, documentType) => {
    if(!data) return
    return data.find(item => item.validationType === documentType);
}

export const isPdfPasswordProtected = async (pdfBuffer) => {
    try {
        const pdfDoc = await PDFDocument.load(pdfBuffer, { ignoreEncryption: true });
        const isPasswordProtected = pdfDoc.isEncrypted;
        return isPasswordProtected;
    } catch (error) {
        console.error('Error al verificar el archivo PDF:', error);
        return false;
    }
}

export const isPdfCorrupt = async (pdfBuffer) => {
    try {
        await PDFDocument.load(pdfBuffer); // Intenta cargar el PDF, si tiene éxito, no está corrupto.
        return false;
    } catch (error) {
        console.error('Error al cargar el archivo PDF (posiblemente corrupto):', error);
        return true;
    }
}

export const validatePdfFile = async (pdfBuffer) => {
    try {
        // Intenta cargar el documento PDF incluso si está encriptado
        const pdfDoc = await PDFDocument.load(pdfBuffer, { ignoreEncryption: true });

        // Verifica si el PDF está encriptado
        const isPasswordProtected = pdfDoc.isEncrypted;

        // Verifica si el PDF está corrupto
        const pages = pdfDoc.getPages();
        const isValidPdf = pages.length > 0; // Si hay al menos una página, consideramos que el PDF es válido

        const combinedResult = !isPasswordProtected && isValidPdf;

        return combinedResult;
    } catch (error) {
        console.error('Error al verificar el archivo PDF:', error);
        return false;
    }
}

export const getValidationType = (validationType) => {
    switch (validationType) {
        case "ANI":
            return "ani";
        case "MUI":
            return "muisca";
        case "CON":
            return "confronta";
        case "RUE":
            return "rues";
        case "CYC":
            return "CyC";
        case "DAC":
            return "dac";
        default:
            return "NA";
    }
}

export const getPrivileges = (permissions, name) => {
    // Si name es un array, verificar si el usuario tiene al menos uno de los privilegios
    if (Array.isArray(name)) {
        return name.some(privilege => 
            permissions.some(item => item.Privileges.includes(privilege))
        );
    }
    
    // Si name es un string, usar la lógica original
    return permissions.some(item => item.Privileges.includes(name));
};

export const getNamesRoles = (permissions) => {
    return permissions.map(item => item.name);
};

export const findAppID = (permissions, name, appID) => {
    let foundAppID = false;
    permissions.some(item => {
        if(item.Privileges.includes(name)){
            if(item.appId.toLowerCase() === appID.toLowerCase()) foundAppID = true;
        }
    });
    return foundAppID;
};

//Función para validar si una validación es ejecutable
export const validationIsExecutable = (dataValidations, validationType, executionType) => {
    let executionTypeIds = executionType === "identity" ? identityValidationIds : documentaryValidationIds;
    return dataValidations?.some(item =>
        item.validationType === validationType && executionTypeIds.includes(item.execution)
    );
};

export const identityValidationApplyCorrection = (identityReviewConsultationData, type, arrayStatus) => {
    // Buscar el item en validationReview correspondiente al crId actual
    if (identityReviewConsultationData?.searchRecordExists?.validationReview) {
        const validationItem = identityReviewConsultationData.searchRecordExists.validationReview.find(
            (item) => item.validationType === type
        );

        if (validationItem && (arrayStatus.includes(validationItem.validationStatus))) {
            return true
        }
    }
    return false
}

export const validateAllIdentityServicesSatExcept = (data, dataValidations, validationToIgnore) => {
    // Validar que todo el listado de validaciones sea SAT excepto la que se ignora
    if (data?.searchRecordExists?.validationReview) {
        const validationReview = data.searchRecordExists.validationReview;

        // Verificar si todas las validaciones, excepto la que se ignora, son SAT y cumplen con el atributo 'mandatory'
        const allSATExceptIgnored = validationReview.every(item => {
            // Si la validación es la que se ignora, se omite de la verificación
            if (item.validationType === validationToIgnore) {
                return true;
            }

            // Obtener el valor mandatory si aplica o no la obligatoriedad
            const validationConfigMand = getMandatoryByValidationType(dataValidations, item.validationType);

            // Si el tipo de validacion es mandatory valida que estado sea SAT, de lo contrario no valida
            if (validationConfigMand) {
                return item.validationStatus === "SAT"
            }
            else {
                return true;
            }
        });

        return allSATExceptIgnored;
    }
    return false;
}

export const encryptAES = async (data) => {
    try {
        const key = CryptoJS.enc.Utf8.parse(AES_KEY_ECD);
        const iv = CryptoJS.enc.Utf8.parse(AES_IV_ECD);
        const encrypted = CryptoJS.AES.encrypt(data, key, { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 });
        const encryptedText = encrypted.toString();
        return encryptedText;
    } catch (error) {
        console.error("Error al encriptar:", error);
        return null;
    }
};

export const encryptAESPromise = (data) => {
    try {
        const key = CryptoJS.enc.Utf8.parse(AES_KEY_ECD);
        const iv = CryptoJS.enc.Utf8.parse(AES_IV_ECD);
        const encrypted = CryptoJS.AES.encrypt(data, key, { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 });
        const encryptedText = encrypted.toString();
        return encryptedText;
    } catch (error) {
        console.error("Error al encriptar:", error);
        return null;
    }
};

export const decryptAES = (encryptedText) => {
    try {
        const key = CryptoJS.enc.Utf8.parse(AES_KEY_ECD);
        const iv = CryptoJS.enc.Utf8.parse(AES_IV_ECD);
        const decrypted = CryptoJS.AES.decrypt(
            {
                ciphertext: CryptoJS.enc.Base64.parse(encryptedText)
            },
            key,
            { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }
        );
        const originalText = decrypted.toString(CryptoJS.enc.Utf8);
        console.log("Texto descifrado:", originalText);
        return originalText;
    } catch (error) {
        console.error("Error al descifrar:", error);
        return null;
    }
}

export const containsAllDocumentTypes = (documentTypes, consultFiles) => {
    // Validar si todos los documentTypes están presentes en consultFiles
    const containsAllDocTypes = documentTypes.every(type =>
        consultFiles.some(file => file.documentTypeId === type && (file.documentstatusid === "PEN" || file.documentstatusid === "APR"))
    );
    return containsAllDocTypes
}

export const constructRequestDocumentValidation = (data,tableDataState) => {
    // construcion de request para validacion de documentos 
    const { externalRequestId, documentTypesToReject, consultFiles } = data
    const valuesDocuments = [];

    // Filtrar duplicados y documentos con documentstatusid que sean "PEN" o "APR"
    const filteredFiles = consultFiles.filter((file, index, self) =>
        index === self.findIndex((f) => (
            f.documentTypeId === file.documentTypeId && (f.documentstatusid === "PEN" || f.documentstatusid === "APR")
        ))
    );

    if (filteredFiles && filteredFiles.length > 0) {
        // Iterar sobre filteredFiles y comparar con documentTypesToReject para definir su respectivo status
        filteredFiles.forEach(data => {
            // Crear el objeto con la estructura deseada
            // En caso de no ser rechazado se deja en estado PEN para que posteriormente pueda ser aprobado o rechazado (debido a que si es APR no se puede rechazar despues)
            if (typesDocsToValidateStatus.includes(data.documentTypeId)) {
                const rejectedDocument = {
                    documentType: data.documentTypeId,
                    documentStatus: documentTypesToReject.includes(data.documentTypeId) ? "NAP" : "APR"
                };
                // Agregar el objeto al array rejectedDocuments
                valuesDocuments.push(rejectedDocument);
            }
        });
    }

    let documentListVD = [];
    let validationReviewDin = [];
    let viaTypeDocument = "ANI";
    if (tableDataState.some(item => item.step === "Dac")) {
        viaTypeDocument = "DAC";
    }
    valuesDocuments.forEach(value => {
        documentListVD.push({
            "documentType": value.documentType,
            "fields": [
                {
                    "fieldName": "status",
                    "isValidate": value.documentStatus === "NAP" ? false : true,
                },
            ],
            "validationDateTime": moment().format(),
            "observation": value.documentStatus === "NAP" ? textVerification.documentIncorrectlyCorrected : textVerification.approvedDocument,
            "reason": value.documentStatus === "NAP" ? textVerification.documentIncorrectlyCorrected : textVerification.approvedDocument,
            "documentStatus": value.documentStatus
        })

        validationReviewDin.push({
            "validationType": value.documentType === "VIA" ? viaTypeDocument : value.documentType === "VIC" ? "CON" : value.documentType,
            "validationStatus": value.documentStatus === "NAP" ? "NST" : "SAT",
            "message": value.documentStatus === "NAP" ? textVerification.documentIncorrectlyCorrected : textVerification.approvedDocument,
        })
    });

    return {
        dataValidateDocument: {
            "externalRequestId": externalRequestId.toString(),
            "documentList": documentListVD,
            "documents": getDocumentsToValidateCheck(documentListVD)
        },
        dataUpdatingIdentityVal: {
            "externalRequestId": externalRequestId,
            "validationReview": validationReviewDin
        }
    };
}

export const updateCheckTableData = (data) => {
    //Actualizar data de tabla de verificación
    const { tableDataState, dataInitial } = data

    // Crear una copia de tableDataState para trabajar con ella
    let updatedTableDataState = tableDataState.map(item => ({ ...item }));

    // Iterar sobre cada elemento en dataInitial.consultFiles
    dataInitial.consultFiles.forEach(file => {
        // Documento subsanado de confronta (VIC): Verificar el valor de documentTypeId y trae los documentos que esten en estado "PEN" o "APR"
        if (file.documentTypeId === "VIC" && (file.documentstatusid === "PEN" || file.documentstatusid === "APR")) {
            // Buscar el objeto correspondiente en tableDataState y agregar el soporte
            const confrontaIndex = updatedTableDataState.findIndex(item => item.step === "Confronta");
            if (confrontaIndex !== -1) {
                updatedTableDataState[confrontaIndex].support = file.filePath;
            }
        }
        // Documento subsanado de ani (VIA): Verificar el valor de documentTypeId y trae los documentos que esten en estado "PEN" o "APR"
        else if (file.documentTypeId === "VIA" && (file.documentstatusid === "PEN" || file.documentstatusid === "APR")) {
            // Buscar el objeto correspondiente en tableDataState y agregar el soporte
            const aniIndex = updatedTableDataState.findIndex(item => (item.step === "Ani" || item.step === "Dac"));
            if (aniIndex !== -1) {
                updatedTableDataState[aniIndex].support = file.filePath;
            }
        }
        // Documento subsanado de VIM (VIM): Verificar el valor de documentTypeId y trae los documentos que esten en estado "PEN" o "APR"
        else if (file.documentTypeId === "VIM" && (file.documentstatusid === "PEN" || file.documentstatusid === "APR")) {
            // Buscar el objeto correspondiente en tableDataState y agregar el soporte
            const VIMIndex = updatedTableDataState.findIndex(item => item.step === textValidationVIM.nameInStepByStepVIM);
            if (VIMIndex !== -1) {
                updatedTableDataState[VIMIndex].support = file.filePath;
            }
        }
        //else if VID validacion dac para agregar support
    });
    return updatedTableDataState;
}

export const getCurrentDateTime = () => {
    const currentDate = new Date();
    const day = currentDate.getDate().toString().padStart(2, '0');
    const month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
    const year = currentDate.getFullYear();
    const hours = currentDate.getHours().toString().padStart(2, '0');
    const minutes = currentDate.getMinutes().toString().padStart(2, '0');
    const seconds = currentDate.getSeconds().toString().padStart(2, '0');
    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
};


export const getExecutionByValidationType = (data, validationType) => {
    // Busca el objeto que tiene el validationType dado
    const validationObject = data.find(obj => obj.validationType === validationType);
    // Si se encuentra el objeto, devuelve el valor de execution; de lo contrario, devuelve false
    return validationObject ? validationObject.execution : false;
}

export const getMandatoryByValidationType = (data, validationType) => {
    // Busca el objeto que tiene el validationType dado
    const validationObject = data.find(obj => obj.validationType === validationType);
    // Si se encuentra el objeto, devuelve el valor de execution; de lo contrario, devuelve false
    return validationObject ? validationObject.mandatory : false;
}

export const filterInfoValidationsApply = (values, identityValidationsApplyData, executionType) => {
    // Crear una nueva variable para almacenar los datos filtrados con los valores calculados
    let newIdentityValidationsApplyData = identityValidationsApplyData.map(item => {
        if (item.validationType === "DAC") {
            return {
                ...item,
                execution: validationIsExecutable(identityValidationsApplyData, item.validationType, executionType),
                fingerPrintCode: values[item.field] !== null ? values[item.field].toUpperCase().slice(0, 6) : '',
                identificationNumber: values["documentNumber"]
            };
        }
        else {
            // Crear un nuevo objeto con los valores del objeto original y la nueva propiedad identificationNumber
            return {
                ...item,
                execution: validationIsExecutable(identityValidationsApplyData, item.validationType, executionType),
                identificationNumber: values[item.field || "documentNumber"]
            };
        }
    });
    return newIdentityValidationsApplyData;
};

const capitalize = (text) => {
    if (!text) return '';

    return text
        .toLowerCase()
        .trim()
        .split(/\s+/)
        .map((word, index) => {
            if (arrayValidationConectors.includes(word.toLowerCase()) && index !== 0) {
                return word;
            }
            return word.charAt(0).toUpperCase() + word.slice(1);
        })
        .join(' ');
};

export const convertFullName = ({ firstName, secondName, surName, secondSurname }) => {
    return [firstName, secondName, surName, secondSurname]
        .filter(Boolean)
        .map(capitalize)
        .join(' ');
};

export const getImagesArray = (data) => {
    return data.filter(info => info.Type.includes("image"));
};

export const getImageMimeType = (base64String) => {
    if (base64String.startsWith("/9j/")) {
      return "image/jpeg";
    } else if (base64String.startsWith("iVBOR")) {
      return "image/png";
    } else if (base64String.startsWith("R0lGOD")) {
      return "image/gif";
    }
    return "application/octet-stream"; // Tipo por defecto si no se reconoce
  };

export const downloadFileb64Pdf = (data) => {
    const { b64, fileName } = data;
    // Decodificar el base64 y convertirlo en un blob
    const byteCharacters = atob(b64); // Decodifica base64
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/pdf' });

    // Crear un enlace de descarga
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName; // Nombre del archivo a descargar
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

export const consultObjectByValue = (object,value) => {
    return object[value];
  };

export const replaceLongStringsInObject = (obj) => {
    const longKeys = {}; // Objeto para almacenar las llaves y valores originales

    const replaceLongStrings = (obj, parentKey = '') => {
        const newObj = Array.isArray(obj) ? [...obj] : { ...obj }; // Crear una copia del objeto o array
        for (const key in newObj) {
            const fullKey = parentKey ? `${parentKey}.${key}` : key;
            if (typeof newObj[key] === 'string' && newObj[key].length > limitCharacters) {
                longKeys[fullKey] = newObj[key]; // Agregar la llave y el valor original al objeto
                newObj[key] = `${fullKey}`;
            } else if (typeof newObj[key] === 'object' && newObj[key] !== null) {
                newObj[key] = replaceLongStrings(newObj[key], fullKey); // Recursión
            }
        }
        return newObj;
    };

    const modifiedObj = replaceLongStrings(obj);
    return { modifiedObj, longKeys };
};